<template>
  <div class="bottom-equip">
    <repair></repair>
    <equalarm></equalarm>
    <equshow></equshow>
  </div>
</template>

<script>
import repair from './repair'
import equalarm from './equalarm'
import equshow from './equshow'
export default {
  data() {
    return {

    }
  },
  components: {
    repair,
    equalarm,
    equshow
  },
  methods: {

  },

}
</script>

<style scoped>
.bottom-equip{
  width: 100vw;
  height: 280px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
  box-sizing: border-box;
  display: flex;
  padding: 0 54px;
  justify-content: space-between;
}
</style>
